import React, { useEffect } from "react";
import { renderStrapiContent } from "../utils/contentfulOptions";
import StrapiImage from "../components/StrapiImage";
import FullPageLoader from "../components/FullPageLoader";
import CornerApple from "../images/corner/corner-apple.webp";

const GivingBack = ({ info }) => {
  useEffect(() => {
    document.title = "Auburn Road - Giving Back";
    return () => {
      document.title = "Auburn Road Vineyards";
    };
  }, []);

  if (!info) {
    return <FullPageLoader />;
  }

  return (
    <>
      <img className="corner-apple" src={CornerApple} alt="" />
      <div className="container content-page p-t-100">
        <section className="content-hero">
          <p className="content-hero__kicker">Community</p>
          <h1 className="huge-text-no-quote content-hero__title">
            Giving Back
          </h1>
          <p className="content-hero__intro">
            Charitable partnerships and local causes we are proud to support.
          </p>
        </section>

        <section className="content-story content-story--copy-only">
          <div className="content-story__copy">
            {renderStrapiContent(info.content)}
          </div>
        </section>

        {info.partnership?.length > 0 && (
          <section className="content-section">
            <h2 className="content-section__heading">
              Charitable Partnerships
            </h2>
            {info.partnership.map((p, index) => (
              <article key={p.id || index} className="content-partner">
                {p.image && (
                  <img
                    className="content-partner__logo"
                    src={StrapiImage(p.image, "small")}
                    alt={p.partnership}
                  />
                )}
                <div className="content-story__copy">
                  <h3 className="content-partner__name">{p.partnership}</h3>
                  {renderStrapiContent(p.content)}
                </div>
              </article>
            ))}
          </section>
        )}
      </div>
    </>
  );
};

export default GivingBack;
